var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "classScheduleST" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "curriculum-tab" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              "header-cell-style": { background: "#eef1f6", color: "#606266" },
              data: _vm.list,
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "course_title",
                label: "课程名称",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "course_time", label: "时间", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return _vm._l(row.course_time, function (item, index) {
                      return _c("div", { key: index }, [_vm._v(_vm._s(item))])
                    })
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "class_form", label: "上课形式", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scoped) {
                    return [
                      _c("pre", [_vm._v(_vm._s(scoped.row.class_form_title))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "teacher_title",
                label: "任课老师",
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [_c("span"), _vm._v("我的课表")])
  },
]
render._withStripped = true

export { render, staticRenderFns }